"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import MapMarkersController from "src/decidim/map/controller/markers";
import MapController from "src/decidim/map/controller";
const SIZE = 36;
const CABA_GEOJSON_URL = "/datos/capas/caba.json";
const CABA_PADDING = 0.035;
const CABA_FALLBACK_BOUNDS = [[-34.706, -58.532], [-34.525, -58.335]];
const constrainedMaps = /* @__PURE__ */ new WeakSet();
let cabaGeoJSONPromise;
const cabaGeoJSON = () => {
  if (!cabaGeoJSONPromise) {
    cabaGeoJSONPromise = fetch(CABA_GEOJSON_URL, { headers: { Accept: "application/json" } }).then((response) => {
      if (!response.ok) {
        throw new Error(`limites CABA ${response.status}`);
      }
      return response.json();
    });
  }
  return cabaGeoJSONPromise;
};
const exteriorRings = (data) => data.features.flatMap((feature) => {
  const { geometry } = feature;
  if (!geometry) {
    return [];
  }
  if (geometry.type === "Polygon") {
    return [geometry.coordinates[0]];
  }
  if (geometry.type === "MultiPolygon") {
    return geometry.coordinates.map((polygon) => polygon[0]);
  }
  return [];
});
const leafletRing = (ring) => ring.map(([longitude, latitude]) => [latitude, longitude]);
const installCabaViewport = (map) => {
  if (!map || constrainedMaps.has(map)) {
    return;
  }
  constrainedMaps.add(map);
  let cityBounds = L.latLngBounds(CABA_FALLBACK_BOUNDS);
  const frameCity = () => {
    const minZoom = map.getBoundsZoom(cityBounds, false, L.point(18, 18));
    const maxBounds = cityBounds.pad(CABA_PADDING);
    map.setMinZoom(minZoom);
    map.setMaxBounds(maxBounds);
    map.options.maxBoundsViscosity = 1;
    if (!maxBounds.contains(map.getCenter()) || map.getZoom() < minZoom) {
      map.fitBounds(cityBounds, { animate: false, padding: [18, 18] });
    }
  };
  frameCity();
  map.on("resize", frameCity);
  cabaGeoJSON().then((data) => {
    if (!map.getPane("caba-mask")) {
      map.createPane("caba-mask").style.zIndex = 350;
      map.getPane("caba-mask").style.pointerEvents = "none";
    }
    if (!map.getPane("caba-boundary")) {
      map.createPane("caba-boundary").style.zIndex = 390;
      map.getPane("caba-boundary").style.pointerEvents = "none";
    }
    const boundary = L.geoJSON(data, {
      pane: "caba-boundary",
      interactive: false,
      style: {
        color: "#725238",
        fillOpacity: 0,
        opacity: 0.42,
        weight: 1.25
      }
    }).addTo(map);
    cityBounds = boundary.getBounds();
    const world = [[-85, -180], [85, -180], [85, 180], [-85, 180]];
    const holes = exteriorRings(data).map(leafletRing);
    L.polygon([world, ...holes], {
      pane: "caba-mask",
      interactive: false,
      stroke: false,
      fillColor: "#f8f5ef",
      fillOpacity: 0.9,
      fillRule: "evenodd"
    }).addTo(map);
    frameCity();
  }).catch((error) => console.error("[caba-map]", error));
};
const iconFor = (color) => L.divIcon({
  html: `
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${SIZE}px" height="${SIZE}px" style="color:${color}"><path fill="none" d="M0 0h24v24H0z"/><path fill="currentColor" d="M18.364 17.364L12 23.728l-6.364-6.364a9 9 0 1 1 12.728 0zM12 15a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm0-2a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"/></svg>`,
  iconAnchor: [0.5 * SIZE, SIZE],
  popupAnchor: [0, -0.5 * SIZE]
});
const clusterIcon = (cluster) => L.divIcon({
  html: `<div style="background:#9a6a3a;color:#fffaf2;border-radius:9999px;width:36px;height:36px;display:flex;align-items:center;justify-content:center;font-weight:600;border:2px solid #fffaf2;box-shadow:0 1px 4px rgba(0,0,0,.35)">${cluster.getChildCount()}</div>`,
  className: "typed-markers-cluster",
  iconSize: [36, 36]
});
class TypedMapMarkersController extends MapMarkersController {
  addMarkers(markersData) {
    if (this.markerClusters === null) {
      this.markerClusters = new L.MarkerClusterGroup({ iconCreateFunction: clusterIcon });
      this.map.addLayer(this.markerClusters);
    }
    $.template(
      this.config.popupTemplateId,
      $(`#${this.config.popupTemplateId}`).html()
    );
    const bounds = new L.LatLngBounds(
      markersData.map(
        (markerData) => [markerData.latitude, markerData.longitude]
      )
    );
    markersData.forEach((markerData) => {
      let marker = new L.Marker([markerData.latitude, markerData.longitude], {
        icon: markerData.iconColor ? iconFor(markerData.iconColor) : this.createIcon(),
        keyboard: true,
        title: markerData.title
      });
      let node = document.createElement("div");
      $.tmpl(this.config.popupTemplateId, markerData).appendTo(node);
      marker.bindPopup(node, {
        maxWidth: this.map.getSize().x * 0.8,
        keepInView: true,
        closeButton: false
      }).openPopup();
      this.markerClusters.addLayer(marker);
    });
    const size = this.map.getSize();
    if (size.y >= 400 && size.x >= 400) {
      this.map.fitBounds(bounds, { padding: [60, 60] });
    } else if (size.y >= 120 && size.x >= 120) {
      this.map.fitBounds(bounds, { padding: [30, 30] });
    } else {
      this.map.fitBounds(bounds);
    }
    if (this.config.minFitZoom && this.map.getZoom() < this.config.minFitZoom) {
      this.map.setView(bounds.getCenter(), this.config.minFitZoom);
    }
  }
}
const RAMPS = {
  accent: ["#f3e8da", "#dfc3a1", "#c99a62", "#9a6a3a", "#6e4a26"],
  semaforo: ["#2f8f4e", "#a3b93f", "#e6c33f", "#e07b39", "#d1242f"]
};
const buildChoropleth = (data, rawCfg) => {
  const cfg = __spreadProps(__spreadValues({}, rawCfg), { colorScale: rawCfg.colorScale || rawCfg.color_scale, metricLabel: rawCfg.metricLabel || rawCfg.metric_label, metricUnit: rawCfg.metricUnit || rawCfg.metric_unit });
  const ramp = RAMPS[cfg.colorScale] || RAMPS.accent;
  const values = data.features.map((f) => f.properties.valor).filter((v) => v !== null && v !== void 0).sort((a, b) => a - b);
  const breaks = [1, 2, 3, 4].map((i) => values[Math.floor(values.length * i / 5)]);
  const colorFor = (v) => {
    let idx = 0;
    breaks.forEach((b) => {
      if (v >= b) {
        idx += 1;
      }
    });
    return ramp[idx];
  };
  const layer = L.geoJSON(data, {
    style: (feature) => ({
      fillColor: colorFor(feature.properties.valor),
      fillOpacity: 0.65,
      color: "#ffffff",
      weight: 1.5
    }),
    onEachFeature: (feature, poly) => {
      const p = feature.properties;
      poly.bindPopup(`<strong>Comuna ${p.comuna}</strong><br>${cfg.metricLabel || "Valor"}: ${p.valor}${cfg.metricUnit || ""}<br><span style="font-size:11px;opacity:.7">${p.barrios || ""}</span>`);
      poly.on("mouseover", () => poly.setStyle({ fillOpacity: 0.85 }));
      poly.on("mouseout", () => poly.setStyle({ fillOpacity: 0.65 }));
    }
  });
  const legend = L.control({ position: "bottomright" });
  legend.onAdd = () => {
    const div = L.DomUtil.create("div");
    div.style.cssText = "background:rgba(255,250,242,.94);padding:8px 12px;border-radius:8px;font-size:12px;box-shadow:0 1px 4px rgba(0,0,0,.2)";
    const bounds = [values[0], ...breaks, values[values.length - 1]];
    let html = `<strong>${cfg.metricLabel || ""}</strong><br>`;
    ramp.forEach((color, i) => {
      html += `<span style="display:inline-block;width:12px;height:12px;background:${color};margin-right:6px;vertical-align:-1px"></span>${bounds[i]}\u2013${bounds[i + 1]}${cfg.metricUnit || ""}<br>`;
    });
    div.innerHTML = html;
    return div;
  };
  return { layer, legend };
};
const buildMarkersLayer = (markers) => {
  const cluster = new L.MarkerClusterGroup({ iconCreateFunction: clusterIcon });
  markers.forEach((m) => {
    const marker = new L.Marker([m.latitude, m.longitude], {
      icon: m.iconColor ? iconFor(m.iconColor) : void 0,
      keyboard: true,
      title: m.title
    });
    let items = "";
    try {
      items = JSON.parse(m.items).map((i) => i.text).join(" \xB7 ");
    } catch (e) {
      items = "";
    }
    marker.bindPopup(`<a href="${m.link}" style="font-weight:600">${m.title}</a><br><span style="font-size:11px;opacity:.7">${items}</span>`);
    cluster.addLayer(marker);
  });
  return cluster;
};
class ChoroplethController extends MapController {
  start() {
    this.map.setView([-34.6118, -58.4428], 11);
    fetch(this.config.geojsonUrl, { headers: { Accept: "application/json" } }).then((response) => {
      if (!response.ok) {
        throw new Error(`capa ${response.status}`);
      }
      return response.json();
    }).then((data) => {
      const { layer, legend } = buildChoropleth(data, this.config);
      layer.addTo(this.map);
      legend.addTo(this.map);
      this.map.fitBounds(layer.getBounds(), { padding: [10, 10] });
    }).catch((error) => console.error("[choropleth]", error));
  }
}
class MultiLayerController extends MapController {
  start() {
    this.map.setView([-34.6118, -58.4428], 11);
    const control = L.control.layers({}, {}, { collapsed: false, position: "topright" });
    control.addTo(this.map);
    let fitted = false;
    (this.config.layers || []).forEach((layerCfg) => {
      if (layerCfg.kind === "choropleth") {
        fetch(layerCfg.geojsonUrl || layerCfg.geojson_url, { headers: { Accept: "application/json" } }).then((response) => response.json()).then((data) => {
          const { layer, legend } = buildChoropleth(data, layerCfg);
          const showLegend = () => {
            if (!legend._map) {
              legend.addTo(this.map);
            }
          };
          const hideLegend = () => {
            if (legend._map) {
              this.map.removeControl(legend);
            }
          };
          if (layerCfg.exclusive) {
            control.addBaseLayer(layer, layerCfg.label);
            this.map.on("baselayerchange", (event) => {
              if (event.layer === layer) {
                showLegend();
              } else {
                hideLegend();
              }
            });
          } else {
            control.addOverlay(layer, layerCfg.label);
            this.map.on("overlayadd", (event) => {
              if (event.layer === layer) {
                showLegend();
              }
            });
            this.map.on("overlayremove", (event) => {
              if (event.layer === layer) {
                hideLegend();
              }
            });
          }
          if (layerCfg.visible) {
            layer.addTo(this.map);
            showLegend();
          }
          if (!fitted) {
            this.map.fitBounds(layer.getBounds(), { padding: [10, 10] });
            fitted = true;
          }
        }).catch((error) => console.error("[multi-layer]", error));
      } else if (layerCfg.kind === "markers") {
        const layer = buildMarkersLayer(layerCfg.markers || []);
        control.addOverlay(layer, layerCfg.label);
        if (layerCfg.visible) {
          layer.addTo(this.map);
        }
      }
    });
  }
}
const originalCreateMapController = window.Decidim.createMapController;
window.Decidim.createMapController = (mapId, config) => {
  let controller;
  if (config.type === "typed-markers") {
    controller = new TypedMapMarkersController(mapId, config);
  } else if (config.type === "choropleth") {
    controller = new ChoroplethController(mapId, config);
  } else if (config.type === "multi-layer") {
    controller = new MultiLayerController(mapId, config);
  } else {
    controller = originalCreateMapController(mapId, config);
  }
  const originalStart = controller.start.bind(controller);
  controller.start = (...args) => {
    const result = originalStart(...args);
    installCabaViewport(controller.map);
    return result;
  };
  return controller;
};
